import React from "react";

export const DividerLine = ({ isEmpty, gap }) => (
    <div className={`dividerLine${isEmpty ? " isEmpty":""}`} style={{ margin: gap }}></div>
);

export const DivideBorderLine = ({ isEmpty, gap }) => (
    <div className={`divideBorderLine${isEmpty ? " isEmpty":""}`} style={{ margin: gap }}></div>
);